export default function PHP_is_scalar() {
  return (
    <div>
      <h1>PHP_is_scalar</h1>
    </div>
  );
}
